import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import { Field, useFormikContext } from 'formik';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import webhookService from 'v2/services/webhook';

import type { IFieldsTestWebHook, IProductWebhook } from 'v2/interfaces/webhook/webhook';

import styles from '../styles';

const Fields = memo(() => {
  const classes = styles();

  const { isSubmitting, resetForm } = useFormikContext<IFieldsTestWebHook>();

  const [loading, setLoading] = useState<boolean>(true);
  const [products, setProducts] = useState<IProductWebhook[]>([]);

  const getProducts = useCallback(() => {
    webhookService
      .getProducts()
      .pipe()
      .subscribe((res) => {
        setProducts(res.data.map((p: IProductWebhook) => ({ label: p.title, value: p.productId })));
        setLoading(false);
      }, toast.error);
  }, []);

  useEffect(() => {
    getProducts();
  }, [getProducts]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Field id='webhook-field-name' name='name' label='Nome' fullWidth component={TextFormField} />
      </Grid>

      <Grid item xs={12}>
        <Field
          id='webhook-field-product'
          name='product'
          label='Produto'
          disabled={loading}
          fullWidth
          options={products}
          component={SelectFormField}
        />
      </Grid>

      <Grid item xs={12}>
        <Field id='webhook-field-url' name='url' label='URL' fullWidth component={TextFormField} />
      </Grid>

      <Grid item xs={12}>
        <div className={classes.alignRight}>
          <Button disabled={isSubmitting} onClick={() => resetForm()}>
            Cancelar
          </Button>

          <Button
            disabled={isSubmitting}
            type='submit'
            variant='contained'
            color='secondary'
            startIcon={isSubmitting && <CircularProgress size={16} />}
          >
            Atualizar
          </Button>
        </div>
      </Grid>
    </Grid>
  );
});

export default Fields;
